import { mount } from '@cdn/app';

mount(document.getElementById('root') as HTMLElement);
